import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ListCompanyPage from '../company/presentation/components/page/ListCompanyPage'
import CreateCompanyPage from '../company/presentation/components/page/CreateCompanyPage'
import CompanyDetailPage from 'company/presentation/components/page/DetailCompanyPage'

const CompanyRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ListCompanyPage />} />
            <Route path="/create" element={<CreateCompanyPage />} />
            <Route path="/:id" element={<CompanyDetailPage />} />
        </Routes>
    )
}

export default CompanyRoutes
